var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExpandless(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 7,
    viewBox: "0 0 12 7",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.8999 0.3L5.9999 4.2L2.0999 0.3C1.6999 -0.1 1.0999 -0.1 0.699902 0.3C0.299902 0.7 0.299902 1.3 0.699902 1.7L5.2999 6.3C5.6999 6.7 6.2999 6.7 6.6999 6.3L11.2999 1.7C11.6999 1.3 11.6999 0.7 11.2999 0.3C10.8999 -0.1 10.2999 -0.1 9.8999 0.3Z",
    fill: "#0C55B8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandless);
export default __webpack_public_path__ + "static/media/expandless.96cec4ca490862c82db94ada3b393831.svg";
export { ForwardRef as ReactComponent };